import React from 'react';
import {StyledProductList} from './StyledProductList';
import {graphql, StaticQuery} from "gatsby";
import Product from "./Product";

const ProductListTemplate = ({data}) => {

    const products = data.allMarkdownRemark.edges;

    return (
        <StyledProductList>
            {products.map(product => <Product product={product}/>)}
        </StyledProductList>
    )
};

const ProductList = () => {
    return (
        <StaticQuery
            query={productListQuery}
            render={data => <ProductListTemplate data={data}/>}
        />
    );
};


const productListQuery = graphql`
    query ProductListQuery {
        allMarkdownRemark(sort: {order: DESC, fields: [frontmatter___date]}, filter: {frontmatter: {templateKey: {eq: "product-post"}}}) {
            edges {
                node {
                    excerpt(pruneLength: 400)
                    id
                    fields {
                        slug
                    }
                    rawMarkdownBody
                    html
                    frontmatter {
                        title
                        description
                        gallery {
                            id
                            childImageSharp {
                                gatsbyImageData(layout: CONSTRAINED)
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default ProductList;
